<template>
    <div class="calculadora" v-if="isMobile()">
        <h1 class="titulo_precio">Precios</h1>
        <b-row class="">
            <b-col sm="12">
                <div class="mb-4">
                    <h1 class="titulo">Selecciona la cantidad de colaboradores</h1>
                    <div style="margin-top: 35px;">
                        <div class="slidecontainer">
                            <div class="value-container" id="value-container">
                                <span>{{ num_empleado }}</span>
                            </div>
                            <input type="range" min="1" max="1000" v-model="num_empleado" class="custom-slider" id="range-slider" />
                        </div>
                        <div class=" d-flex">
                            <b-col sm="6" xs="6" class="text-left">
                                <span class="text-range">1</span>
                            </b-col>
                            
                            <b-col sm="6" class="text-right">
                                <span class="text-range">1000</span>
                            </b-col>
                        </div>
                    </div>
                    <div class="col-lg-12 d-flex  mt-3"> 
                        
                        <b-col sm="6" class="text-right">
                            <div class="switch">
                                <input id="switch1" type="checkbox" class="switch__input" @click="changePlan(1)" v-model="selected_month_plan" >
                                <label for="switch1" class="switch__label">Mensual</label>
                            </div>
                        </b-col>
                        <b-col sm="6" class="text-left">
                            <div class="switch">
                                <input id="switch2" type="checkbox" class="switch__input" @click="changePlan(2)" v-model="selected_year_plan" >
                                <label for="switch2" class="switch__label">Anual</label>
                            </div>
                        </b-col>
                    </div>
                    <div class="card_footer_contact d-flex">
                        <p class="mr-1">¿Más de 1000 colaboradores?</p>
                        <b-link @click="linkContact()">Contáctanos.</b-link>
                    </div>
                </div>
                <hr class="custom-hr2"/>
            </b-col>
            <b-col sm="12">
                <div class="mb-5">
                    <h1 class="plan_titulo"> BASIC </h1>
                    <h2 class="plan_subtitulo">Sistema básico</h2>
                    <br>
                    <p class="precio">
                        <span >$</span>{{planLTE}}
                    </p>
                    <br>
                    <br>
                    <br>
                    <p class="card_footer">
                        por empleado <br>
                        <span>$129.99 MXN / mensual</span>
                    </p>
                </div>
                <hr class="custom-hr2"/>
            </b-col>
            <b-col sm="12">
                <div class="">
                    <h1 class="plan_titulo"> PREMIUM </h1>
                    <h2 class="plan_subtitulo">Sistema completo</h2>
                    <br>
                    <p class="precio">
                        <span >$</span>{{planPRO}}
                    </p>
                    <br>
                    <br>
                    <br>
                    <p class="card_footer">
                        por empleado <br>
                        <span>$169.99 MXN / mensual</span>
                    </p>
                </div>
            </b-col>
        </b-row>
        <!--<b-row >
            <b-col>
                <h1 class="titulo_precio2" >Solicita tu demostración</h1>
                
            </b-col>
            <b-button to="/about" pill size="sm" class="btnDemo" type="submit">Solicitar demo</b-button>
        </b-row>-->
    </div>
    <div class="calculadora" v-else>
        <h1 class="titulo_precio">Precios</h1>
        <div class="mid_text col-lg-12">
            <p>Elige tu plan ideal, también puedes solicitar una cotización personalizada al <b-link @click="linkContact()">agendar tu demo.</b-link> </p>
        </div>
        <b-row class="panel_precios">
            <b-col sm="6">
                <div class="caja">
                    <h1 class="titulo">Selecciona la cantidad de colaboradores</h1>
                    <div style="margin-top: 35px;">
                        <div class="slidecontainer">
                            <div class="value-container" id="value-container">
                                <span>{{ num_empleado }}</span>
                            </div>
                            <input type="range" min="1" max="1000" v-model="num_empleado" class="custom-slider" id="range-slider" />
                        </div>
                        <b-row>
                            <b-col sm="4" class="text-left">
                                <span class="text-range">1</span>
                            </b-col>
                            <b-col sm="4" class="text-left">
                                <span class="text-range">Elige tu plan de pago.</span>
                            </b-col>
                            <b-col sm="4" class="text-right">
                                <span class="text-range">1000</span>
                            </b-col>
                        </b-row>
                    </div>
                    <b-row class="mt-5">
                        <b-col sm="2"></b-col>
                        <b-col sm="3" class="text-right">
                            <div class="switch">
                                <input id="switch1" type="checkbox" class="switch__input" @click="changePlan(1)" v-model="selected_month_plan" >
                                <label for="switch1" class="switch__label">Mensual</label>
                            </div>
                        </b-col>
                        <b-col sm="2"></b-col>
                        <b-col sm="3" class="text-left">
                            <div class="switch">
                                <input id="switch2" type="checkbox" class="switch__input" @click="changePlan(2)" v-model="selected_year_plan" >
                                <label for="switch2" class="switch__label">Anual</label>
                            </div>
                        </b-col>
                    </b-row>
                    <div class="card_footer_contact d-flex">
                        <p class="mr-1">¿Más de 1000 colaboradores?</p>
                        <b-link @click="linkContact()">Contáctanos.</b-link>
                    </div>
                </div>
            </b-col>
            <b-col sm="3">
                <div class="caja">
                    <h1 class="plan_titulo"> BASIC </h1>
                    <h2 class="plan_subtitulo">Sistema básico</h2>
                    <br>
                    <p class="precio">
                        <span >$</span>{{planLTE}}
                    </p>
                    <br>
                    <br>
                    <br>
                    <p class="card_footer">
                        por empleado <br>
                        <span>$129.99 MXN / mensual</span>
                    </p>
                </div>
            </b-col>
            <b-col sm="3">
                <div class="caja">
                    <h1 class="plan_titulo"> PREMIUM </h1>
                    <h2 class="plan_subtitulo">Sistema completo</h2>
                    <br>
                    <p class="precio">
                        <span >$</span>{{planPRO}}
                    </p>
                    <br>
                    <br>
                    <br>
                    <p class="card_footer">
                        por empleado <br>
                        <span>$169.99 MXN / mensual</span>
                    </p>
                </div>
            </b-col>
        </b-row>
        <!--<b-row style="margin: 180px 0px;" >
            <b-col>
                <h1 class="titulo_precio">Solicita tu demostración</h1>
                <b-button to="/about" pill size="sm" class="my-2 my-sm-0 btnDemo" type="submit">Solicitar demo</b-button>
            </b-col>
        </b-row>-->
    </div>
</template>

<script>
  export default {
    data() {
      return {
        num_empleado: 100,
        selected_month_plan: true,
        selected_year_plan: false,
        precioLTE: 129.99,
        precioPRO: 169.99,
        precioPlanLTE: 0,
        precioPlanPRO: 0,
        planMultiplier:1,
      }
    },
    watch: {
        num_empleado: (value) => {
            document.getElementById("range-slider").style.background    = 'linear-gradient(to right, rgba(45, 185, 209, 0.5) 0%, rgba(45, 185, 209, 0.5) 0%' + (value - 1)/10 + '%, #F2F2F2 ' + (value - 1)/10 + '%, #F2F2F2 100%)';
            document.getElementById("value-container").style.marginLeft = `${value <= 500 ? (value - 6)/10 : (value - 115)/10}%`;
        }
    },
    methods: {
        changePlan(type){
            switch (type){
                case 1:
                    if(this.selected_month_plan == false){
                        this.selected_year_plan = false;
                        this.planMultiplier = 1;
                    }else{
                        this.selected_year_plan = true;
                        this.planMultiplier = 12;
                    }
                    break;
                case 2:
                    if(this.selected_year_plan == false){
                        this.selected_month_plan = false;
                        this.planMultiplier = 12;
                    }else{
                        this.selected_month_plan = true;
                        this.planMultiplier = 1;
                    }
                    break;
            }
        },
        isMobile() {
            var check = false;
            //console.log(window.screen.width);
            if(window.screen.width < 769){
                return check=true;
            }
        },
        linkContact(){
            setTimeout(function(){
                window.location = "#contacto"; 
                },100);
        },
        
    },
    computed:{
        planLTE (){
            this.precioPlanLTE = (this.num_empleado * this.precioLTE) * this.planMultiplier;
            return this.precioPlanLTE.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        },
        planPRO(){
            this.precioPlanPRO = (this.num_empleado * this.precioPRO) * this.planMultiplier;
            return this.precioPlanPRO.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        }
    },
    mounted() {
        
        document.getElementById("range-slider").style.background    = 'linear-gradient(to right, rgba(45, 185, 209, 0.5) 0%, rgba(45, 185, 209, 0.5) 0% ' + this.num_empleado/10 + '%, #F2F2F2 ' + this.num_empleado/10 + '%, #F2F2F2 100%)';
        document.getElementById("value-container").style.marginLeft = `${(this.num_empleado - 6)/10}%`;
    }
    
  }
</script>

<style scoped>

 .mid_text > p{
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    letter-spacing: 0.2px;
    color: #4F4F4F;
  }

  .mid_text > p > a{
      color:#3C64B1;
  }
    .calculadora {
        width: 100%;
    }
    .caja{
        background: #FFFFFF;
        border: 1px solid #F3F3F3;
        box-sizing: border-box;
        padding: 10px 20px;
        margin-bottom: 20px;
        box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.15);
        border-radius: 25px;
        height: 330px;
    }
    .panel_precios {
        padding-top: 50px;
        padding-bottom: 50px;
    }
    .titulo {
        font-family: Muli-Extrabold;
        font-style: normal;
        font-size: 20px;
        line-height: 33px;
        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;

        margin-top: 25px;
        color: #1E2144;
    }
    .plan_titulo {
        font-family: Muli-Extrabold;
        font-style: normal;
        font-size: 18px;
        line-height: 18px;
        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;

        margin-top: 27px;
        color: #2db9d1;
    }
    .plan_subtitulo {
        font-family: Muli-Semibold;
        font-style: normal;
        font-size: 14px;
        line-height: 18px;
        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;
        margin-top: 20px;
        color: #1E2144;
    }
    .precio {
        font-family: Muli-Semibold;
        font-style: normal;
        font-size: 40px;
        line-height: 18px;
        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;
        margin-top: 20px;
        border: 0;
        color: #1E2144;
        background-color: #FFFFFF;
    }

    .titulo_precio {
        font-family: Muli-Extrabold;
        font-style: normal;
        font-size: 38px;
        line-height: 18px;
        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;

        padding-bottom: 60px;
        color: #1E2144;
    }

    .card_footer {
        left: calc(50% - 162px/2 + 65px);
        top: calc(50% - 83px/2 + 2524.5px);

        font-family: Muli-Semibold;
        font-style: normal;
        font-size: 12px;
        line-height: 18px;
        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;

        color: #1E2144;
    }

    .card_footer_contact p{
        margin-left: auto;
        font-family: Muli-Semibold;
        font-style: normal;
        font-size: 12px;
        line-height: 33px;

        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;

        color: #828282;
    }

    .card_footer_contact a{
        margin-right: auto;
        font-family: Muli-Semibold;
        font-style: normal;
        font-size: 12px;
        line-height: 33px;

        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;
        color: #2DB9D1;
    }
    .card_footer span {
        color: #2DB9D1;
    }

    .btnDemo {
        font-family: Muli-Bold;
        font-style: normal;
        font-size: 14px;
        line-height: 18px;
        padding: 13px 27px;
        color: #FFF ;
        background: #2DB9D1;
        border-color: #2DB9D1;
        border-radius: 18px;
    }

    .slidecontainer {
        width: 100%; /* Width of the outside container */
    }

    .value-container {
        width: 77px;
        height: 35px;
        background: #2DB9D1;
        border-radius: 16px;
        margin-bottom: 10px;
    }

    .value-container span {
        font-family: Muli-Semibold;
        font-style: normal;
        font-size: 17px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;

        margin-top: 5px !important;
        display: -webkit-inline-box;
        overflow: hidden;
    }

    /* The slider itself */
    .custom-slider {
        -webkit-appearance: none; /* Override default CSS styles */
        appearance: none;
        width: 100%; /* Full-width */
        height: 14px;
        border-radius: 10px;
        background: #F2F2F2; /* Grey background */
        outline: none; /* Remove outline */
        -webkit-transition: .2s; /* 0.2 seconds transition on hover */
        transition: opacity .2s;
    }

    /* Mouse-over effects */
    .custom-slider:hover {
        opacity: 0.8; /* Fully shown on mouse-over */
    }

    /* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
    .custom-slider::-webkit-slider-thumb {
        -webkit-appearance: none; /* Override default look */
        appearance: none;
        width: 20px; /* Set a specific slider handle width */
        height: 20px;
        border-radius: 50%;
        cursor: pointer; /* Cursor on hover */
        background: #2DB9D1;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.24);
    }

    .custom-slider::-moz-range-thumb {
        width: 20px; /* Set a specific slider handle width */
        height: 20px;
        border-radius: 50%;
        cursor: pointer; /* Cursor on hover */
        background: #2DB9D1;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.24);
    }

    span.text-range {
        font-family: Muli-Semibold;
        font-style: normal;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0.2px;

        color: #2DB9D1;
    }

    /**
    *   SWITCH CSS
    */
    .switch {
        display: inline-block;
        position: relative;
        margin: 0 0 10px;
        font-size: 16px;
        line-height: 24px;
    }

    .switch__input {
        position: absolute;
        top: 0;
        left: 0;
        width: 36px;
        height: 20px;
        opacity: 0;
        z-index: 0;
    }

    .switch__label {
        font-family: Muli-Semibold;
        font-style: normal;
        font-size: 12px;
        line-height: 18px;

        display: block;
        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;
        color: #1E2245;

        padding: 3px 0 0 44px;
        cursor: pointer;
    }

    .switch__label:before {
        content: '';
        position: absolute;
        top: 5px;
        left: 0;
        width: 36px;
        height: 14px;
        background-color: rgba(34, 31, 31, 0.26);
        border-radius: 14px;
        z-index: 1;
        -webkit-transition: background-color 0.28s cubic-bezier(0.4, 0, 0.2, 1);
        transition: background-color 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .switch__label:after {
        content: '';
        position: absolute;
        top: 2px;
        left: 0;
        width: 20px;
        height: 20px;
        background-color: #F1F1F1;
        border-radius: 14px;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
        z-index: 2;
        -webkit-transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
        transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
        -webkit-transition-property: left, background-color;
        transition-property: left, background-color;
    }

    .switch__input:checked + .switch__label:before {
        background-color: #2DB9D1;
        mix-blend-mode: normal;
        opacity: 0.5;
    }

    .switch__input:checked + .switch__label:after {
        left: 16px;
        background-color: #2DB9D1;
    }

    @media(max-width: 768px){
        .titulo_precio{
            font-size: 26px;
            line-height: 18px;  

            margin-top: -10px;
            margin-bottom: 0px;
            color: #1E2144;
        }
        .titulo_precio2 {
            font-family: Muli-Extrabold;
            font-style: normal;
            font-weight: bold;
            font-size: 22px;
            line-height: 18px;  
            align-items: center;
            text-align: center;
            letter-spacing: 0.2px;

            padding-top: 25px;
            padding-bottom: 15px;
            color: #1E2144;
        }


        .plan_titulo { 
            margin-top: 40px;
        }

        .titulo {
            margin-top: 0px;
        }

        .btnDemo {
            width: 100%; 
            margin-bottom: 25px;
            padding-bottom: 13px;
            padding-top:13px;
            border-radius: 14px;
        }

        .custom-hr2{
            margin-left: -2%;
            margin-right: -2%;
            border: 0.01px solid #3C64B1;
        }
    }
</style>